( function () {
	'use strict';

	/* @ngInject */
	function DeleteConfirmationController ( $scope, $q, coreservice, logger, type, $modalInstance, fileService ) {
		var self = this;

		self.deleteLoading = false;

		function confirmDelete () {
			if ( type === 'Evidence-file' ) {
				var fileId = $scope.$parent.evidenceFileData.fileId;
				var params = {
					'type'          : $scope.$parent.evidenceFileData.fileType,
					'observationId' : $scope.$parent.observation.id,
					'userId'        : $scope.$parent.evidenceFileData.userId
				};

				self.deleteLoading = true;

				fileService.remove( fileId, params )
				.finally( function () {
					self.deleteLoading = false;
					$modalInstance.close();
				} );
			} else {
				$modalInstance.close();
			}
		}

		function cancelDelete () {
			$modalInstance.dismiss();
		}

		function chooseActionText () {
			switch ( type ) {
				case 'clearTime' : {
					self.action = 'Reset';
					break;
				}

				default : {
					self.action = 'Delete';
				}
			}
		}

		function activate () {
			logger.info( 'Activated Delete Confirmation Controller' );

			chooseActionText();

			if ( type === 'Group' ) {
				self.type = 'Section';
				return self;
			} else if ( type === 'Indicator' ) {
				self.type = 'Item';
				return self;
			}

			self.type = type;
		}

		activate();

		self.title         = 'DeleteConfirmationController';
		self.confirmDelete = confirmDelete;
		self.cancelDelete  = cancelDelete;
	}

	angular
		.module( 'app.components' )
		.controller( 'DeleteConfirmationController', DeleteConfirmationController );

	DeleteConfirmationController.$inject = [ '$scope', '$q', 'coreservice', 'logger', 'type', '$modalInstance', 'fileService' ];
} )( );
